import { render, staticRenderFns } from "./category_add.vue?vue&type=template&id=11b729cf&scoped=true&"
import script from "./category_add.vue?vue&type=script&lang=js&"
export * from "./category_add.vue?vue&type=script&lang=js&"
import style0 from "./category_add.vue?vue&type=style&index=0&id=11b729cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b729cf",
  null
  
)

export default component.exports